import CustomRangePanel from "./customRangePanel.container";

export default CustomRangePanel;
